import { CommonModule } from '@angular/common';
import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import { WmsDialogHeaderComponent } from '../../../components/wms-dialog-header/wms-dialog-header.component';
import { WmsDialogBodyComponent } from '../../../components/wms-dialog-body/wms-dialog-body.component';
import { WmsDialogFooterComponent } from '../../../components/wms-dialog-footer/wms-dialog-footer.component';
import { BaseComponent } from '../../../components/base/base.component';
import {WmsMessageComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {DialogService, NotificationService, PreferenceService, ProjectService} from "@wms/services";
import {VcsService} from "@wms/app/vcs/services/vcs.service";
import {get, trim} from "lodash-es";
import {ProjectShellService} from "@wms/app/project-shell.service";
import {replace} from "@wm/core";
import {VcsAPIService} from "@wms/app/vcs/services/vcs-api/vcs-api.service";

@Component({
  selector: 'wms-export-ProjectShell-dialog',
  standalone: true,
  templateUrl: './export-ProjectShell-dialog.component.html',
  styleUrls: ['./export-ProjectShell-dialog.component.less'],
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    FormsModule
  ]
})
export class ExportProjectShellDialogComponent extends BaseComponent  implements OnInit{
  disableDialogActions: any;
  showCommitMsg: boolean;
  projectData: any;
  message: any;
  vcsCommitMsg: any;
  projectName: string;
  projectDetails: any
  vcsService: VcsService
  vcsApiService: VcsAPIService;
  dialogService: DialogService;
  projectShellService: ProjectShellService;
  warnDuplicateProjectShellName: boolean;
  notificationService: NotificationService;
  preferenceService: PreferenceService

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.vcsApiService = inject(VcsAPIService);
    this.dialogService = inject(DialogService);
    this.preferenceService = inject(PreferenceService);
    this.projectShellService = inject(ProjectShellService)
    this.notificationService = inject(NotificationService);
  }

  ngOnInit() {
    this.showCommitMsg = true;
    this.vcsService.setVCSCommitMsg(true).then(() => {
      this.vcsCommitMsg = this.vcsService.vcsCommitMsg

    })
    this.projectDetails = this.projectService.getDetails()
    this.projectName = this.projectDetails.name
    this.projectData = {};
    if (this.projectName) {
      this.projectData.name = this.projectName + '_Copy';
    }
    this.projectData.name = this.projectDetails.name
    this.projectData.displayName = this.projectDetails.displayName || ""
    this.projectData.isUserDefined = false;
    this.projectData.commitMsg = '';
  }

  saveProjectAsProjectShell() {
    var targetName = this.projectData.displayName && trim(this.projectData.displayName);
    var commitMsg = this.projectData.commitMsg ? this.projectData.commitMsg + '\n' + this.vcsCommitMsg : this.vcsCommitMsg;
    if (!targetName) {
      this.showErrMsg(this.locale.MESSAGE_WARN_PROJECT_SHELL_NAME_EMPTY_DESC);
      return;
    }

    /* Warns if the projectShell name entered has special characters which we won`t allow*/
    if (this.validateProjectShellName()) {
      /*Check if a projectShell already exists by the given name, if exists warns.*/
      this.projectShellService.list().then((list) => {
        if (this.warnDuplicateProjectShellName) {
          this.confirmActionOk(targetName, commitMsg);
          return;
        }
        var duplicateName = list.some((projectShell: any) => {
          return projectShell.name.toLowerCase() === targetName.toLowerCase();
        });
        if (duplicateName) {
          this.showWarnMsg(replace(this.locale.MESSAGE_WARN_PROJECT_SHELL_NAME_DUPLICATE_DESC, [targetName]));
          this.warnDuplicateProjectShellName = true;
        } else {
          this.confirmActionOk(targetName, commitMsg);
        }
      })
    }
  }

  confirmActionOk(targetProjectShellName: string, commitMsg: any) {

    if (this.preferenceService.hasAccess('project.vcs.view')) {

      //if vcs is available then push the project first then publish the project
      let vcsParams:any = {}
      vcsParams.commitMessagePrefix = commitMsg
      this.vcsApiService.pushChanges(vcsParams).then(() => {
        this.exportProjectAsProjectShell(targetProjectShellName)
      }, (errMsg) => {
        if (get(errMsg.error.errors, 'error[0].messageKey') === "com.wavemaker.vcs$NothingToPush") {
          this.exportProjectAsProjectShell(targetProjectShellName)
        } else {
          this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, get(errMsg.error.errors, 'error[0].message'));
        }

      });
    } else {
      this.exportProjectAsProjectShell(targetProjectShellName);
    }
    this.dialogService.close('DialogExportProjectAsProjectShell')
  }

  exportProjectAsProjectShell(targetProjectShellName: string) {
    this.projectService.export({
      'projectId': this.projectDetails.id,
      'targetName': targetProjectShellName,
      'exportType': 'PROJECTSHELL'
    }).then(() => {
        this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_SUCCESS_SAVE_PROJECT_AS_PROJECT_SHELL_DESC);
      },
      (error) => {
        this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, typeof error === "string" ? error : this.locale.MESSAGE_ERROR_SAVE_PROJECT_AS_PROJECT_SHELL_DESC);
      });
  }




  hideErrMsg() {

  }

  close(id: string) {
    this.dialogService.close(id);

  }

  validateProjectShellName(): any {
    this.hideErrMsg();
    if (this.projectData.displayName.replace(/_/g, '').length === 0) {
      this.showErrMsg(this.locale.MESSAGE_WARN_PROJECT_SHELL_NAME_UNDERSCORE_DESC);
    } else {
      return true;
    }
  };

  showErrMsg(msg: any) {
    this.message = {
      type: 'error',
      caption: msg
    };
  }

  showWarnMsg(msg: any) {
    this.message = {
      type: 'warn',
      caption: msg
    };
  }
}
